import clsx from 'clsx';
import Image from 'next/image';
import notFoundImage from '@/assets/img/dobrozem-not-found.svg';
import okLogo from '@/assets/img/dobrozem-ok.svg';
import sadLogo from '@/assets/img/dobrozem-sad.svg';
import smileLogo from '@/assets/img/dobrozem-smile.svg';
import successLogo from '@/assets/img/dobrozem-sucess.svg';
import { RichText } from '../RichText';
import { Text } from '../Text';
import styles from './StatusMessage.module.scss';
type Props = {
  buttonsChildren: JSX.Element;
  className?: string;
  description?: string;
  logoStatus: 'notFound' | 'ok' | 'sad' | 'smile' | 'successful';
  richText?: Record<string, unknown>[];
};
const LogoStatusIconMap: Record<Props['logoStatus'], string> = {
  notFound: notFoundImage,
  ok: okLogo,
  sad: sadLogo,
  smile: smileLogo,
  successful: successLogo
};
export const StatusMessage = ({
  buttonsChildren,
  className,
  description,
  logoStatus,
  richText
}: Props) => {
  return <div className={clsx(styles.wrapper, className)} data-sentry-component="StatusMessage" data-sentry-source-file="StatusMessage.tsx">
      <Image alt='status logo' className={styles.logo} src={LogoStatusIconMap[logoStatus]} data-sentry-element="Image" data-sentry-source-file="StatusMessage.tsx" />
      {richText && <RichText className={styles.richText} content={richText} customRenderText={({
      text
    }) => <Text className={styles.description} tag='p' type='p3'>
              {text}
            </Text>} />}
      {description && <Text className={styles.description} tag='p' type='p3'>
          {description}
        </Text>}
      <div className={styles.buttonsWrapper}>{buttonsChildren}</div>
    </div>;
};